var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "banner-container",
    class: _vm.color
  }, [_c('div', {
    staticClass: "banner-top"
  }, [_c('div', {
    staticClass: "banner-view"
  }, [_c('div', {
    staticClass: "banner-icon"
  }, [_c('img', {
    attrs: {
      "id": "banner-icon-img",
      "src": _vm.iconType,
      "alt": _vm.iconType
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-slot"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm.comments || _vm.additionalInfo ? _c('div', {
    staticClass: "banner-button"
  }, [_c('v-button', {
    staticClass: "small subtle",
    class: _vm.color,
    on: {
      "click": _vm.toggle
    }
  }, [!_vm.isCollapsed ? _c('img', {
    attrs: {
      "src": _vm.plusIcon,
      "alt": "Plus icon"
    }
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.isCollapsed ? "Collapse" : _vm.buttonTitle) + "\n      ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "banner-bottom"
  }, [_vm.comments && _vm.isCollapsed ? _c('div', {
    staticClass: "banner-rejected-info",
    attrs: {
      "alt": "comments"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.comments)
    }
  })]) : _vm._e(), _vm._v(" "), _vm.additionalInfo && _vm.isCollapsed ? _c('div', {
    staticClass: "banner-rejected-info",
    attrs: {
      "alt": "additional information"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.additionalInfo))])]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }